import React, { useState, useEffect } from 'react';
import LoadingIcons from 'react-loading-icons';
import { useDispatch } from 'react-redux';
import HedgeFillsList from './Container/HedgeFillsList';
import OrderDetails from './Container/OrderDetails';
import { clearSelectedOrder, retrieveOrderList } from 'store/modules/order';

export default function HedgeFillsWindow(props) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [currentMode, setCurrentMode] = useState('list');

  const handleModeChange = (mode) => {
    setCurrentMode(mode);
  };

  const changeToList = () => {
    dispatch(clearSelectedOrder());
    // dispatch(retrieveOrderList(true, '', ''));
  };

  const [deviceType, setDeviceType] = useState('');
  useEffect(() => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
        navigator.userAgent
      )
    ) {
      setDeviceType('Mobile');
    } else {
      setDeviceType('Browser');
    }
  }, []);

  const handleCurrentContainer = () => {
    switch (currentMode) {
      case 'list':
        return (
          <HedgeFillsList
            onModeChange={handleModeChange}
            deviceType={deviceType}
          />
        );

      case 'detail':
        return (
          <OrderDetails
            onModeChange={handleModeChange}
            returnBack={changeToList}
          />
        );

      default:
        return <div>{"I'm sorry an error has occured"}</div>;
    }
  };

  return isLoading ? (
    <div className="location-loading-icon">
      <LoadingIcons.Oval stroke="#006730" />
      <br /> <br />
    </div>
  ) : (
    <div className="all-orders-form">
      <div className="handle-container" style={{ backgroundColor: 'white' }}>
        {handleCurrentContainer()}
      </div>
    </div>
  );
}
